import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button
} from 'semantic-ui-react'

const CardPreAssessmentActionLogUX = (props: any) => {
    return(
      <div>
        <div
          id="CardPreAssessmentActionLogUX-div-4"
          style={ {fontWeight: "bold", fontSize:"large",padding: "20px"}}>
          {props.languageUX === "en" ? "Recording history" : "ประวัติการบันทึกแก้ไข"}
        </div>
        <div
          id="CardPreAssessmentActionLogUX-div-3">
          
          <Table
            data={props.actionLogData}
            headers={props.languageUX === "en" ? "User, Remark, Department, Date-time" : "ผู้บันทึก,หมายเหตุ,แผนก,วันที่ เวลา"}
            id="CardPreAssessmentActionLogUX-Table-1"
            keys="name,remark,division_name,edited"
            minRows="9"
            showPagination={false}
            style={{padding: "20px"}}>
          </Table>
        </div>
        <div
          id="CardPreAssessmentActionLogUX-div-5"
          style={{display: "flex", justifyContent: "space-between", padding: "20px"}}>
          
          <div
            id="CardPreAssessmentActionLogUX-div-2">
            {props.paginationComponent}
          </div>
          <Button
            id="CardPreAssessmentActionLogUX-Button-7"
            onClick={props.onDismiss}>
            {props.languageUX === "en" ? "OK" : "ตกลง"}
          </Button>
        </div>
      </div>
    )
}


export default CardPreAssessmentActionLogUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 1,
      "name": "Table",
      "parent": 3,
      "props": {
        "data": {
          "type": "code",
          "value": "props.actionLogData"
        },
        "headers": {
          "type": "value",
          "value": "ผู้บันทึก,หมายเหตุ,แผนก,วันที่ เวลา",
          "valueEN": "User, Remark, Department, Date-time"
        },
        "id": {
          "type": "value",
          "value": "CardPreAssessmentActionLogUX-Table-1"
        },
        "keys": {
          "type": "value",
          "value": "name,remark,division_name,edited"
        },
        "minRows": {
          "type": "value",
          "value": "9"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"20px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.paginationComponent"
        },
        "id": {
          "type": "value",
          "value": "CardPreAssessmentActionLogUX-div-2"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPreAssessmentActionLogUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการบันทึกแก้ไข",
          "valueEN": "Recording history"
        },
        "id": {
          "type": "value",
          "value": "CardPreAssessmentActionLogUX-div-4"
        },
        "style": {
          "type": "code",
          "value": " {fontWeight: \"bold\", fontSize:\"large\",padding: \"20px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPreAssessmentActionLogUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", padding: \"20px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ตกลง",
          "valueEN": "OK"
        },
        "id": {
          "type": "value",
          "value": "CardPreAssessmentActionLogUX-Button-7"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDismiss"
        }
      },
      "seq": 7,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardPreAssessmentActionLogUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
